import { gql } from "@apollo/client";

export const PAYMENT_PROCESSORS_QUERY = gql`
  query GetPaymentProcessors {
    paymentProcessors {
      id
      label
      storeProcessorId
      apiCredentialId
      interactionType
      outlets {
        id
        label
      }
    }
  }
`;
